import styled from 'styled-components';

export const ChatInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100px;
  gap: 24px;
  padding: 16px;
  border-radius: 12px;
  border: 1px solid #5C5C5C;
  background-color: #FAFAFA;
  overflow: visible;
`;

export const InputField = styled.textarea`
  flex: 1;
  border: none;
  outline: none;
  resize: none;
  font-family: inherit;
  font-size: 14px;
  line-height: 1.5;
  min-height: 24px;
  max-height: 120px;
  background-color: transparent;
  z-index: 1000000;
  
  &::placeholder {
    color: #BABABA;
  }
  
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
  
  scrollbar-width: thin;
`;

export const ActionsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const MenuWrapper = styled.div`
  position: relative;
  z-index: 9999998;
`;

export const MenuContainer = styled.div`
  position: absolute;
  bottom: 100%;
  left: 0;
  margin-bottom: 2px;
  z-index: 9999999;
  max-height: 300px;
  overflow-y: auto;
  overflow-x: hidden;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  
  scrollbar-width: thin;
  scrollbar-color: #BABABA transparent;
  
  &::-webkit-scrollbar {
    width: 6px;
  }
  
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  
  &::-webkit-scrollbar-thumb {
    background-color: #BABABA;
    border-radius: 3px;
  }
  
  &::-webkit-scrollbar-thumb:hover {
    background-color: #9A9A9A;
  }
`;
